import { EntityTemplateVariables, TemplateVariable } from '@tools/interfaces/template';

export const getSubscriptionCategoryFieldsForEntity = (entity: string): TemplateVariable[] => {
  return [
    {
      label: 'templates.subscription_categories.code.label',
      contentValue: `{{ ${entity}subscriptionCategory.code }}`,
      description: 'templates.subscription_categories.code.description',
    },
    {
      label: 'templates.subscription_categories.name.label',
      contentValue: `{{ ${entity}subscriptionCategory.name }}`,
      description: 'templates.subscription_categories.name.description',
    },
  ];
};

export const templateResource: EntityTemplateVariables = {
  fields: getSubscriptionCategoryFieldsForEntity(''),
  related: [],
  relatedInLoop: [],
};
